<main class="mat-body" *ngIf="client">
    <div class="bg-white">
        <div class="container progress-bar-wrapper">
            <div class="row">
                <div class="col-12">
                    <thr-contract-progress [percent]="10"></thr-contract-progress>
                </div>
            </div>
        </div>
    </div>

    <form #formPerson="ngForm" novalidate autocomplete="off" (submit)="onSubmit()">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row flex-nowrap justify-content-between align-items-end">
                        <div class="col-auto flex-shrink-1">
                            <h1 class="text-blue mat-display-1 mb-0" [innerHTML]="'form.personal-data'|translate"></h1>
                        </div>
                        <div class="col-auto" [ngSwitch]="client.type">
                            <i class="text-blue" *ngSwitchCase="ClientType.DISABLED"></i>
                            <i class="icon-legal text-blue" *ngSwitchCase="ClientType.LEGAL_PERSON"></i>
                            <i class="icon-minor text-blue" *ngSwitchCase="ClientType.MINOR"></i>
                            <i class="icon-natural text-blue" *ngSwitchDefault></i>
                        </div>
                    </div>
                    <hr class="mt-1" />
                    <h2 class="mat-subheading-1 text-blue font-weight-bold mb-4" *ngIf="client.type !== ClientType.LEGAL_PERSON">
                        {{ 'form.first-holder'|translate }}
                    </h2>
                </div>
            </div>
        </div>

        <ng-container [ngSwitch]="client.type">
            <thr-contract-form-legal-person [client]="client" *ngSwitchCase="ClientType.LEGAL_PERSON"></thr-contract-form-legal-person>
            <thr-contract-form-minor-disabled-person
                [client]="client"
                *ngSwitchCase="ClientType.DISABLED"
            ></thr-contract-form-minor-disabled-person>
            <thr-contract-form-minor-disabled-person
                [client]="client"
                *ngSwitchCase="ClientType.MINOR"
            ></thr-contract-form-minor-disabled-person>
            <thr-contract-form-natural-person [client]="client" *ngSwitchDefault></thr-contract-form-natural-person>
        </ng-container>

        <div class="container">
            <div class="row justify-content-end my-4">
                <div class="col-12" *ngIf="isClientPortal">
                    <div
                        #recaptchaDirective="recaptcha"
                        thr-recaptcha
                        name="recaptcha"
                        [(ngModel)]="client.recaptchaToken"
                        #recaptchaCtrl="ngModel"
                    ></div>
                </div>
                <div class="col-10 col-sm-6 col-md-4">
                    <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="gray" [disabled]="!formPerson.valid">
                        {{ 'general.next'|translate }}
                    </button>
                </div>
            </div>
        </div>
    </form>
</main>
